import { Component, OnInit, Input, ElementRef, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { IUploadFile, DocumentManagementService } from '../../../../../common/services/document-management.service';
import { BlobDownloadRequest } from '../../../../../common/models/onBaseIntegrationAndMapping.model';

import { DefaultDisplayComponent } from "../default-display/default-display.component";

@Component({
    selector: 'file-upload-display',
    templateUrl: './file-upload-display.component.html',
    styleUrls: ['./file-upload-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FileUploadDisplayComponent extends DefaultDisplayComponent implements OnInit {
    @ViewChild("downloadLink", { read: ElementRef, static: true })
    public downloadLink: ElementRef;
    public files: IUploadFile[];

    get useRadio(): boolean {
        let result: boolean = false;
        if (this.question && this.question.questionConfig) {
            result = <boolean>this.question.questionConfig.useRadioButtons;
        }
        return result;
    }

    constructor(
        public _docSvc: DocumentManagementService
    ) { super(); }

    ngOnInit() {
        this.files = super.getFiles();
    }

    downloadFile(file: IUploadFile) {
        this._docSvc.downloadBlob({ uri: file.blobUri, contentType: file.type, fileName: file.fileName } as BlobDownloadRequest).subscribe(l => {
            this.renderBlob(l, file.type, file.fileName);
        });
    }

    getOptionText(): string {        
        const value = super.getQuestionValue();
        let option = this.question.questionConfig.radioOptions.find(o => o.id === value);
        if (option) return option.displayText;
        return value;
    }

    private renderBlob(data: any, contentType: string, fileName: string): void {
        const blob = new Blob([data], { type: contentType });
        let url = window.URL.createObjectURL(blob);
        const link = this.downloadLink.nativeElement;
        link.href = url;
        link.download = fileName;
        link.click();
    }
}
